import SupportForm from "@/components/entities/support-form";
import { useTranslations } from "next-intl";
import S from "./index.module.scss";
import { FeedbackResourceFormEnum } from "@/api/generated-api";

const ContactForm = () => {
  const t = useTranslations();

  return (
    <div className={S.wrapper}>
      <SupportForm form={FeedbackResourceFormEnum.Contacts} title={t("form.contactForm")} />
    </div>
  );
};

export default ContactForm;
